import React from "react";
import { Box } from "grid-styled";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import { validate as buildValidations } from "validate-redux-form";
import { notEmpty } from "../utils/validation";
import setInitialValues from "../hocs/setInitialValues";
import H1 from "./Heading";
import Button from "./Button";
import {
  FormSection,
  InputContainer,
  Checkbox,
  AddressFields,
  ContactFields,
  FranchiseSelect,
  SalespersonSelect
} from "./forms";

const validate = values => {
  let errors = buildValidations(values, {
    franchiseId: notEmpty()("A franchise must be specified."),
    contact: {
      firstName: notEmpty()("Please enter a first name."),
      lastName: notEmpty()("Please enter a last name."),
      address: {
        streetAddress: notEmpty()("Please enter a street address."),
        city: notEmpty()("Please enter a city."),
        state: notEmpty()("Please enter a state."),
        zipCode: notEmpty()("Please enter a zip code."),
        country: notEmpty()("Please select a country.")
      }
    }
  });

  if (!values.copyMailingAddress) {
    errors = {
      ...errors,
      ...buildValidations(values, {
        jobSite: {
          streetAddress: notEmpty()("Please enter a street address."),
          city: notEmpty()("Please enter a city."),
          state: notEmpty()("Please enter a state."),
          zipCode: notEmpty()("Please enter a zip code."),
          country: notEmpty()("Please select a country.")
        }
      })
    };
  }

  return errors;
};

const NewJob = ({
  franchise,
  handleSubmit,
  pristine,
  submitting,
  invalid,
  copyMailingAddress,
  franchiseId
}) => (
  <Box p={3}>
    <form onSubmit={handleSubmit}>
      <H1>Add a new job</H1>
      <FormSection title="Franchise Info">
        {!franchise && (
          <Box pb={2}>
            <Field
              name="franchiseId"
              labelText="Franchise"
              placeholder="e.g., Augusta"
              component={InputContainer}
              fieldComponent={FranchiseSelect}
            />
          </Box>
        )}
        <Box pb={2}>
          <Field
            name="salespersonId"
            labelText="Salesperson"
            placeholder="e.g., Victor Sullivan"
            component={InputContainer}
            fieldComponent={SalespersonSelect}
            franchiseId={franchiseId}
          />
        </Box>
      </FormSection>
      <FormSection
        title="Contact Info"
        subtitle="Please provide mailing details here"
      >
        <ContactFields path="contact" />
      </FormSection>
      <FormSection title="Job Site">
        <Box pb={2}>
          <Field name="copyMailingAddress" component={Checkbox}>
            <b>Copy mailing address?</b>
          </Field>
        </Box>
        {!copyMailingAddress && (
          <AddressFields name="Job Site" path="jobSite" />
        )}
      </FormSection>
      <FormSection>
        <Button
          variant="primary"
          disabled={pristine || submitting}
          type="submit"
        >
          Create job
        </Button>
      </FormSection>
    </form>
  </Box>
);

const formName = "newJob";
const selector = formValueSelector(formName);
const enhance = compose(
  connect(state => ({
    copyMailingAddress: selector(state, "copyMailingAddress"),
    franchiseId: selector(state, "franchiseId")
  })),
  setInitialValues(props => ({
    franchiseId: props.franchise && props.franchise.id,
    contact: {
      address: {
        country: "US"
      }
    },
    jobSite: {
      country: "US"
    }
  })),
  reduxForm({
    form: formName,
    validate
  })
);

export default enhance(NewJob);



// WEBPACK FOOTER //
// ./src/components/NewJobForm.js